<template>
    <div class="server-query">
        <el-form inline :model="params">
            <el-form-item>
                <div class="range-select">
                    <el-select
                        v-model="params.begin"
                        size="small"
                        filterable
                        clearable
                        placeholder="服ID"
                        @change="change"
                    >
                        <el-option
                            v-for="item in beginServers"
                            :key="item.server_auto_id"
                            :label="
                                (item.display_server_name || item.server_name) +
                                    '（' +
                                    item.server_id +
                                    '）'
                            "
                            :value="item.server_auto_id"
                        >
                        </el-option>
                    </el-select>
                    <span>至</span>
                    <el-select
                        v-model="params.end"
                        size="small"
                        filterable
                        clearable
                        placeholder="服ID"
                        @change="change"
                    >
                        <el-option
                            v-for="item in endServers"
                            :key="item.server_auto_id"
                            :label="
                                (item.display_server_name || item.server_name) +
                                    '（' +
                                    item.server_id +
                                    '）'
                            "
                            :value="item.server_auto_id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="params.name"
                    size="small"
                    filterable
                    clearable
                    placeholder="服展示名称"
                    @change="change"
                >
                    <el-option
                        v-for="item in srcServers"
                        :key="item.server_auto_id"
                        :label="
                            (item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）'
                        "
                        :value="item.server_auto_id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="params.type"
                    size="small"
                    filterable
                    clearable
                    placeholder="区服类型"
                    @change="change"
                >
                    <el-option label="正式" :value="1"> </el-option>
                    <el-option label="测试" :value="2"> </el-option>
                    <el-option label="审核" :value="3"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="params.status"
                    size="small"
                    filterable
                    clearable
                    placeholder="区服状态"
                    @change="change"
                >
                    <el-option label="正常" :value="1"> </el-option>
                    <el-option label="维护" :value="0"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    name: "ServerQuery",
    data() {
        return {
            params: {
                begin: "",
                end: "",
                name: "",
                status: "",
                type: ""
            },
        };
    },
    props: {
        servers: {
            type: Array,
            required: true
        },
        srcServers: {
            type: Array,
            required: true
        }
    },
    computed: {
        id2childrenIds() {
            let tmp = {},
                setVal = (data = []) => {
                    data.forEach(item => {
                        tmp[item.server_info.server_auto_id] =
                            item.children_auto_ids || [];
                        if (item.children && item.children.length) {
                            setVal(item.children);
                        }
                    });
                };
            setVal(this.servers);
            return tmp;
        },
        serverIds() {
            return this.srcServers.map(v => v.server_auto_id);
        },
        beginServers() {
            if (this.params.end) {
                let idx = this.serverIds.indexOf(this.params.end);
                return this.srcServers.slice(0, idx + 1);
            }
            return this.srcServers;
        },
        endServers() {
            if (this.params.begin) {
                let idx = this.serverIds.indexOf(this.params.begin);
                return this.srcServers.slice(idx);
            }
            return this.srcServers;
        }
    },
    watch: {
        srcServers() {
            this.change();
        }
    },
    methods: {
        reset() {
            this.params = {
                begin: "",
                end: "",
                name: "",
                status: "",
                type: ""
            };
        },
        getSelectedIds() {
            let begin = this.params.begin
                    ? this.serverIds.indexOf(this.params.begin)
                    : 0,
                end = this.params.end
                    ? this.serverIds.indexOf(this.params.end) + 1
                    : this.serverIds.length,
                ids = this.serverIds.slice(begin, end),
                tmp = [];
            ids.forEach(id => {
                tmp.push(id, this.id2childrenIds[id]);
            });
            return tmp.flat();
        },
        change() {
            let params = Object.assign(
                { selectedIds: this.getSelectedIds() },
                this.params
            );
            this.$emit("change", params);
        }
    }
};
</script>
<style lang="scss">
.server-query {
    .el-form {
        display: flex;
        justify-content: flex-end;
        .el-form-item {
            margin-bottom: 0;
            &:last-child {
                margin-right: 0;
            }
        }
        .range-select {
            display: flex;
            & > span {
                margin: 0 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// website/subComponents/ServerQuery.vue